import { createDateTimeColumn, type TableColumnConfig } from '@pct-ng/feature-table-material';

export function createCreatedAtColumn<T>(
  i18nPrefix: string,
  sortable = false,
): TableColumnConfig<T> {
  return createDateTimeColumn<T>(
    'createdAt',
    'createdAt' as keyof T,
    `${i18nPrefix}CREATED_AT`,
    sortable,
  );
}
